export enum MoveType {
  unknown = 0,
  tilt = 1,
  grounded = 2,
  air = 3,
  special = 4,
  dodge = 5,
  throw = 6,
  tech = 7,
  edgeAttack = 8,
  item = 9,
  kirbySpecial = 10,
}
